<template>
  <div :class="`modal ${wide ? 'wide' : ''}`">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    wide: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.modal {
  $margin: 1em;

  background: white;
  box-shadow: 4px 4px 20px rgba(0,0,0,0.2);
  left: 0;
  margin: $margin 0;
  max-width: calc(100vw - #{$margin * 2});
  overflow: hidden;
  padding: 1.6em;
  position: static;
  right: 0;
  top: 40%;
  transform: none;
  transition: transform .5s,opacity .5s;
  width: 600px;

  &.wide {
    width: 750px;
  }
}
</style>



/** WEBPACK FOOTER **
 ** Modal.vue?167dbc10
 **/